import { Component, ChangeDetectionStrategy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TrackerService } from '@app/shared/services/tracker.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'dgx-org-bulk-upload-success-modal',
    templateUrl: './org-bulk-upload-success-modal.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class OrgBulkUploadSuccessModalComponent {
  public i18n = this.translateService.instant([
    'Core_Done',
    'bulkUpdateModal_NotAppearRightAway',
    'bulkUpdateModal_WillSendEmail',
  ]);
  constructor(
    private translateService: TranslateService,
    private trackerService: TrackerService,
    private activeModal: NgbActiveModal
  ) {}

  public done() {
    this.trackerService.trackEventData({ action: 'Bulk upload complete' });
    this.activeModal.close();
  }
}
